export const subjectSubgroupApi = {
    heading:[
        
        {
            head:"Subject Name"
        },
        {
            head:"Subgroup Description"
        },
        {
            head:"Best Count"
        },
        {
            head:"Active From"
        },
        {
            head:"Active To"
        },
        {
            head:"Action"
        }
    ],
    data:[
       {
        subjectname:"Emglish-1",
        subgroupdesctiption:"Vital",
        bestcount:"4",
        activeFrom:"06-06-2023",
        activeTo:"20-06-2023",
         action:"./assets/images/dashboards/adminDashboard/flexvalue/tableactionicon.png"
       },
       {
        subjectname:"Emglish-1",
        subgroupdesctiption:"Vital",
        bestcount:"4",
        activeFrom:"06-06-2023",
        activeTo:"20-06-2023",
         action:"./assets/images/dashboards/adminDashboard/flexvalue/tableactionicon.png"
       },
       {
        subjectname:"Emglish-1",
        subgroupdesctiption:"Vital",
        bestcount:"4",
        activeFrom:"06-06-2023",
        activeTo:"20-06-2023",
         action:"./assets/images/dashboards/adminDashboard/flexvalue/tableactionicon.png"
       },
       {
        subjectname:"Emglish-1",
        subgroupdesctiption:"Vital",
        bestcount:"4",
        activeFrom:"06-06-2023",
        activeTo:"20-06-2023",
         action:"./assets/images/dashboards/adminDashboard/flexvalue/tableactionicon.png"
       },
      
     
   
       
    ]
}